import React from 'react'
import { Box, Paper, Popper, TableCell, TableRow, Typography } from '@mui/material'
import { formatMoney, sectionSx } from '../cashflowUtils'
import { mainRed } from '../../../utils/color'

// alert = số không khớp thống kê, tô đỏ cả thẻ cho dễ thấy
export function MoneyStat({ alert = false, compact = false, label, value, color = '#222', meta }) {
	return (
		<Paper
			className='cashflow-money-card'
			elevation={0}
			sx={{
				...sectionSx,
				...(alert ? { border: `1px solid ${mainRed}`, background: '#FFF6F6' } : null),
				minHeight: compact ? 92 : meta ? 124 : 106,
				height: '100%',
				width: '100%',
				minWidth: 0,
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				px: compact ? 1.75 : 2,
			}}>
			<Typography sx={{ color: alert ? mainRed : '#637381', fontSize: 13, fontWeight: 700 }}>{label}</Typography>
			<Typography
				sx={{
					color,
					fontWeight: 900,
					fontSize: compact ? { xs: 21, md: 22 } : { xs: 22, md: 24 },
					mt: compact ? 0.75 : 1,
					fontVariantNumeric: 'tabular-nums',
				}}>
				{formatMoney(value)}
			</Typography>
			{meta && (
				<Typography sx={{ color: alert ? mainRed : '#637381', fontSize: 12, fontWeight: 700, mt: 0.5 }}>
					{meta}
				</Typography>
			)}
		</Paper>
	)
}

// Cao đúng bằng TextField/Button trong lưới đối soát để các cột không bị thò thụt
export const AUDIT_CONTROL_HEIGHT = 48

export function AuditAmount({ label, value, color = '#111' }) {
	return (
		<Box
			sx={{
				border: '1px solid #DDE7DF',
				borderRadius: '10px',
				px: 1.5,
				py: 0.5,
				background: '#FAFAFA',
				height: AUDIT_CONTROL_HEIGHT,
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				minWidth: 0,
			}}>
			<Typography noWrap sx={{ color: '#637381', fontSize: 11, fontWeight: 700, lineHeight: 1.3 }}>
				{label}
			</Typography>
			<Typography
				noWrap
				sx={{ color, fontWeight: 900, fontSize: 16, lineHeight: 1.3, fontVariantNumeric: 'tabular-nums' }}>
				{formatMoney(value)}
			</Typography>
		</Box>
	)
}

export function EmptyRow({ colSpan, text }) {
	return (
		<TableRow>
			<TableCell colSpan={colSpan} sx={{ textAlign: 'center !important' }}>
				<Typography sx={{ color: '#637381', py: 1 }}>{text}</Typography>
			</TableCell>
		</TableRow>
	)
}

export function OrderPickerPopper(props) {
	return (
		<Popper
			{...props}
			className={`cashflow-order-popper ${props.className || ''}`}
			placement='bottom-start'
			sx={{
				...props.sx,
				width: 'min(860px, calc(100vw - 32px)) !important',
				minWidth: 'min(860px, calc(100vw - 32px))',
				'& .MuiAutocomplete-paper': {
					width: '100%',
				},
				'& .MuiAutocomplete-listbox': {
					maxHeight: 430,
				},
			}}
		/>
	)
}
